<template>
  <div>
    <list-widget :items="maps.items" routeName="map" :hideHeader="true" :changeRoute="true" :addNewTitle="$t('top_bar.add_new_map')" addNewRouteName="add-map">
      <template slot="item-template" slot-scope="props">
        <ListItemTemplate :item="props.item"></ListItemTemplate>
      </template>
    </list-widget>
    <div class="list-widget__footer items-container__footer" v-if="maps.items">
      <slot name="footer"><a class="link" v-on:click.stop.prevent="extendLimit()" v-if="maps.total > maps.items.length">{{ $t('common.load_more') }}</a></slot>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import * as mTypes from 'store/mutation-types';
  import ListWidget from 'common/ListWidget';
  import ListItemTemplate from 'maps/ListItemTemplate';

  export default {
    components: {
      ListWidget,
      ListItemTemplate,
    },
    computed: mapGetters({
      user: 'user/user/user',
      mapLimit: 'landlord/maps/limit',
      maps: 'landlord/maps/maps',
    }),
    created() {
      this.fetchMaps();
    },
    methods: {
      fetchMaps() {
        this.$store.dispatch('landlord/maps/fetch', { keyword: this.$route.query.keyword, user: this.user })
          .then(() => {
            /*
            if (this.maps.total === 0 && !this.$router.params.id) {
              this.$router.push({ name: 'add-map' });
            }
            */
          });
      },
      extendLimit() {
        this.$store.commit(`landlord/maps/${mTypes.SET_LIMIT}`, this.mapLimit + 10);
      },
    },
    data() {
      return {
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/maps/Sidebar.vue